<div fxLayout="row" fxLayoutAlign="start space-between">
  @if (hasFeatureAction) {
    <div>
      <metadata-action [removeTabFocus]="true" [action]="row.FeatureAction" [model]="model" [dense]="true"
        [formData]="getDataController(row.FeatureAction, model.$$TypeName)" [doFetch]="true"
      [fetchEntity]="bindFetchRowModel" [enableShortcut]="false"></metadata-action>
    </div>
  }
  @if (canView) {
    <forge-icon-button tabindex="-1" dense class="tt-margin--left" (contextmenu)="onContextMenu($event, row, true)"
      (mouseup)="middleClick($event, row, true)" (click)="edit(row, true, $event)"
      telemetry="Submission-View">
      <forge-tooltip placement="bottom">View</forge-tooltip>
      <forge-icon name="visibility"></forge-icon>
    </forge-icon-button>
  }

  @if (canEdit) {
    <forge-icon-button tabindex="-1" dense class="tt-margin--left" (contextmenu)="onContextMenu($event, row, false)"
      (mouseup)="middleClick($event, row, false)" (click)="edit(row, false, $event)"
      telemetry="Submission-Edit">
      <forge-tooltip placement="bottom">Edit</forge-tooltip>
      <forge-icon name="edit"></forge-icon>
    </forge-icon-button>
  }

  @if (canDelete) {
    <forge-icon-button tabindex="-1" dense class="tt-margin--left" (click)="delete(row)"
      telemetry="Submission-Delete">
      <forge-tooltip placement="bottom">Delete</forge-tooltip>
      <forge-icon name="delete"></forge-icon>
    </forge-icon-button>
  }

  @if (primaryActions) {
    @for (action of primaryActions; track action.Label) {
      <div class="tt-margin--left">
        <metadata-action [removeTabFocus]="true" [action]="action" [model]="model" [dense]="true"
          [formData]="getDataController(action, model.$$TypeName)" [doFetch]="true"
          [fetchEntity]="bindFetchRowModel" [enableShortcut]="false" (executed)="onActionExecuted()">
        </metadata-action>
      </div>
    }
  }
  @if (hasOverflowActions) {
    <div fxLayout="row" class="tt-margin--left">
      <forge-icon-button tabindex="-1" dense (click)="overflowMenu($event)">
        <forge-icon name="more_vert"></forge-icon>
      </forge-icon-button>
    </div>
  }
</div>

<forge-popover #overFlowMenu placement="bottom-end">
  <forge-list dense="true">
    @for (action of overflowActions; track action.Label) {
      <forge-list-item>
        <button type="button" (click)="performAction(action, $event)" [disabled]="action.Disabled"
          style="color: var(--forge-theme-text-high);">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            {{actionLabel(action.Label)}}
          </div>
        </button>
      </forge-list-item>
    }
  </forge-list>
</forge-popover>
